module.exports = __webpack_public_path__ + "fonts/Austin-Bold.7db266e3.otf";